// AES-256-CBC decrypt using Web Crypto API (matches backend's encryption scheme)
export async function decryptSource(data, key) {
  const raw = atob(data.replace(/ /g, "+"));
  const dataBytes = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) {
    dataBytes[i] = raw.charCodeAt(i);
  }

  const ivLength = 16;
  const iv = dataBytes.slice(0, ivLength);
  const encrypted = dataBytes.slice(ivLength);

  const keyBytesRaw = new TextEncoder().encode(key);
  const keyBytes = new Uint8Array(32);
  keyBytes.set(keyBytesRaw.slice(0, 32));

  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-CBC" },
    false,
    ["decrypt"]
  );

  const decryptedBuffer = await crypto.subtle.decrypt(
    { name: "AES-CBC", iv: iv },
    cryptoKey,
    encrypted
  );

  return new TextDecoder().decode(decryptedBuffer);
}

// source string format: appID_memberID_companyID (e.g. "1_3_4")
export function parseSource(source) {
  const [appID, memberID, companyID] = source.split("_");
  return { appID, memberID, companyID };
}
